<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label"></label>
        </div>
        <div class="field-body">
            <div class="field">
                <label class="checkbox">
                    <input v-model="free_parking" value="1" type="checkbox">
                    Free Parking
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                errors: {
                    free_parking: null
                }
            }
        },
        computed: {
            free_parking: {
                get() {
                    return this.$store.getters.getNewPricePlan.free_parking
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'free_parking', value: value})
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/FreeParkingCheckBox.vue